
import React, { useState } from "react";
import {
  SFStack,
  SFUseStyled,
  SFIcons,
  SFTypography,
  SFIconButton,
  SFAccordion,
  SFAccordionDetails,
  SFAccordionSummary,
  SFGridContainer,
  SFGridItem,
} from "@sf-core";
import { useTranslation } from "react-i18next";

const { styled } = SFUseStyled();

const StyledAccordion = styled(SFAccordion)(({ theme }) => ({
  backgroundColor: theme.palette.grey550.main,
  border: `1px solid ${theme.palette.blue300.main}`,
  borderRadius: theme.spacing(1) + "!important",
  "& .MuiAccordionSummary-root": {
    minHeight: "0px !important",
  },
}));

const SFAccordionSummaryStyled = styled(SFAccordionSummary)(({ theme }) => ({
  backgroundColor: theme.palette.grey550.main,
  flexDirection: "row-reverse",
  borderRadius: theme.spacing(1),
  paddingLeft: theme.spacing(1),
  "& .selected-group-number": {
    fontWeight: 600,
    color: theme.palette.blue300.main,
    paddingLeft: theme.spacing(1),
  },
  "& .selected-group": {
    color: theme.palette.white.main,
    textTransform: "uppercase",
    paddingTop: "1px !important",
  },
}));

const SFAccordionDetailsStyled = styled(SFAccordionDetails)(({ theme }) => ({
  backgroundColor: theme.palette.grey550.main,
  borderRadius: theme.spacing(1),
  padding: 0,
  "& .trend-wrapper": {
    paddingRight: theme.spacing(0.5),
  },
  "& .skill-wrapper": {
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(1.5),
    borderTop: `1px solid ${theme.palette.blue300.main}`,
  },
}));

const AccordionStack = styled(SFStack)(({ theme }) => ({
  padding: theme.spacing(2),
  paddingTop: 0,
}));

const DrawerAccordion = ({
  isSkillDrawer,
  selectedItems,
  setSelectedItems,
  gridRef,
}) => {
  const [expanded, setExpanded] = useState(true);
  const { t } = useTranslation();

  const handleDelete = (item) => {
    setSelectedItems(selectedItems.filter((i) => i.id !== item.id));

    if (gridRef.current) {
      gridRef.current.api.applyServerSideTransaction({
        add: [item],
        route: item.category ? [item.category] : [item.jobFamilyName],
      });
    }
  };

  let accordionTitle = "";
  if (isSkillDrawer) {
    accordionTitle =
      selectedItems?.length > 1
        ? t("profileScreen.drawer.skillSelection.accordionTitlePlural")
        : t("profileScreen.drawer.skillSelection.accordionTitle");
  } else {
    accordionTitle =
      selectedItems?.length > 1
        ? t("profileScreen.drawer.jobSelection.accordionTitlePlural")
        : t("profileScreen.drawer.jobSelection.accordionTitle");
  }

  return (
    <AccordionStack>
      {selectedItems?.length > 0 && (
        <StyledAccordion
          expanded={expanded}
          onChange={() => setExpanded(!expanded)}
        >
          <SFAccordionSummaryStyled>
            <SFStack direction="row" spacing={1}>
              <SFTypography variant="body1" className="selected-group-number">
                {selectedItems?.length}
              </SFTypography>
              <SFTypography variant="body1" className="selected-group">
                {accordionTitle}
              </SFTypography>
            </SFStack>
          </SFAccordionSummaryStyled>
          <SFAccordionDetailsStyled>
            <div className="details-wrapper">
              {selectedItems?.map((item, index) => (
                <div className="skill-wrapper" key={index}>
                  <SFGridContainer alignItems="center">
                    <SFGridItem xs={10}>
                      <SFStack spacing={1}>
                        <SFTypography variant="body2">{item.name}</SFTypography>
                      </SFStack>
                    </SFGridItem>
                    <SFGridItem xs={2}>
                      <SFStack
                        alignItems="center"
                        justifyContent="center"
                        className="trend-wrapper"
                      >
                        <SFIconButton
                          onClick={() => handleDelete(item)}
                          variant="transparent"
                        >
                          <SFIcons.SFRemoveCircleIcon color="red300" />
                        </SFIconButton>
                      </SFStack>
                    </SFGridItem>
                  </SFGridContainer>
                </div>
              ))}
            </div>
          </SFAccordionDetailsStyled>
        </StyledAccordion>
      )}
    </AccordionStack>
  );
};

export default DrawerAccordion;